import { AxiosResponse } from 'axios'
import { makeAPIRequest } from '../utils/request';

interface GetAllEntityParams {
  page: number;
  pageSize: number;
  searchData: {
    selectedValue: never[],
    searchTerm?: string
  }
};

interface GetAllEntityResponse {
  count: number;
  rows: [];
};

interface CreateUpdateEntityParams {
  bannerImage: string;
  companyName: string;
  address: string;
  contactNumber: string;
  description: string;
  websiteLink: string;
  email: string;
};

export interface FormItem {
    contentCollectionId?: string;
    isLifeTime: boolean;
    expiredOn: number | null;
};

interface ShareContentAccessParams {
    contentCollections: FormItem[];
};

interface AssociateDepartmentsToContentParams {
    contentCollectionId: string;
    departments: string[]
};

interface CommonResponse {
  data:{}
};

class EntityAPI {

  async getAllEntity(params: GetAllEntityParams): Promise<GetAllEntityResponse> {
    const jwt = localStorage.getItem('access-token');
    const offset = params.page * params.pageSize;
    const limit = params.pageSize;
    const searchCompany =  params.searchData.searchTerm;
    const categoryIds= params.searchData.selectedValue.join(",");;


    const res: AxiosResponse = await makeAPIRequest({
        method: 'GET',
        url: `/api/entities?offset=${offset}&limit=${limit}&companyName=${searchCompany}&category=${categoryIds}`,
        headers: {
            Authorization: `Bearer ${jwt}`,
        },
    });

    return res.data.data;
  };

  async createEntity(data: CreateUpdateEntityParams, categoryId: string): Promise<CommonResponse> {
    const jwt = localStorage.getItem('access-token')
    const res: AxiosResponse = await makeAPIRequest({
      method: 'POST',
      url: `/api/category/${categoryId}/entity`,
      data,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    })
    return res.data
  };

  async updateEntity(entityId: string, data: CreateUpdateEntityParams): Promise<CommonResponse> {
    const jwt = localStorage.getItem('access-token')
    const res: AxiosResponse = await makeAPIRequest({
      method: 'PUT',
      url: `/api/entity/${entityId}`,
      data,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    })
    return res.data
  };

  async getEntityById(entityId: string | undefined): Promise<CommonResponse> {
    const jwt = localStorage.getItem('access-token')
    const res: AxiosResponse = await makeAPIRequest({
      method: 'GET',
      url: `/api/entity/${entityId}`,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    })
    return res.data
  }
  async enabledDisabledEntity(entityId: string, data: {enabled: boolean}): Promise<CommonResponse> {
    const jwt = localStorage.getItem('access-token')
    const res: AxiosResponse = await makeAPIRequest({
      method: 'PUT',
      url: `/api/contacts/${entityId}/activateOrDeactivateContact`,
      data,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    })
    return res.data
  };

  async shareContentAccess(entityId: string, data: ShareContentAccessParams): Promise<CommonResponse> {
      const jwt = localStorage.getItem('access-token');
      const res: AxiosResponse = await makeAPIRequest({
        method: 'POST',
        url: `/api/entity/${entityId}/shareContentCollection`,
        data,
        headers: {
          Authorization: `Bearer ${jwt}`,
        },
      });
      
      return res.data;
  };

  async updateShareContentAccess(entityId: string, contentId: string, data: FormItem): Promise<CommonResponse> {
      const jwt = localStorage.getItem('access-token');
      const res: AxiosResponse = await makeAPIRequest({
        method: 'PUT',
        url: `/api/entity/${entityId}/contentCollection/${contentId}`,
        data,
        headers: {
          Authorization: `Bearer ${jwt}`,
        },
      });
      return res.data;
  };

  async revokeAccess(entityId: string, contentId: string): Promise<CommonResponse> {
    const jwt = localStorage.getItem('access-token');
    const res: AxiosResponse = await makeAPIRequest({
      method: 'DELETE',
      url: `/api/entity/${entityId}/contentCollection/${contentId}`,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    });
    return res.data;
  };

  async associateDepartmentsToContent(entityId: string, data: AssociateDepartmentsToContentParams): Promise<CommonResponse> {
      const jwt = localStorage.getItem('access-token');
      const res: AxiosResponse = await makeAPIRequest({
        method: 'POST',
        url: `/api/entity/${entityId}/department/shareContentCollection`,
        data,
        headers: {
          Authorization: `Bearer ${jwt}`,
        },
      });
      return res.data;
  };

}

const entityApi = new EntityAPI(); 
export default entityApi;